import * as yup from 'yup';
import i18next from 'i18next';
import { MAX_TITLE_LENGTH } from '../isValidFolderName';

function getGallectionFoldersRenameValidationSchema() {
  return yup.object({
    type: yup
      .string()
      .oneOf(
        ['gallery', 'collection', 'stash', 'private_collection'],
        i18next.t('validation.gallectionFoldersRename.type.oneOf')
      )
      .required(i18next.t('validation.gallectionFoldersRename.type.required')),
    username: yup.string().optional(),
    folderid: yup
      .number()
      .integer(i18next.t('validation.gallectionFoldersRename.folderId.integer'))
      .required(i18next.t('validation.gallectionFoldersRename.folderId.required')),
    name: yup
      .string()
      .required(i18next.t('validation.gallectionFoldersRename.name.required'))
      .max(
        MAX_TITLE_LENGTH,
        i18next.t('validation.gallectionFoldersRename.name.max', {
          max: MAX_TITLE_LENGTH,
        })
      )
      .test(
        'max-bytes',
        i18next.t('validation.gallectionFoldersRename.name.maxBytes', {
          max: MAX_TITLE_LENGTH,
        }),
        value => {
          if (!value) return true;
          return new Blob([value]).size <= MAX_TITLE_LENGTH;
        }
      )
      .matches(
        /^[ \w$?:.,'"\-+]+$/,
        i18next.t('validation.gallectionFoldersRename.name.invalidCharacters')
      ),
  });
}

/**
 * Validates gallection folders rename request data using Yup schema
 * Based on papiRequestDaSharedGallectionFoldersRenameSchema
 * @param data The request data to validate
 * @returns boolean indicating if validation passed
 */
export function validateGallectionFoldersRenameRequest(data: any): boolean {
  try {
    getGallectionFoldersRenameValidationSchema().validateSync(data, {
      abortEarly: false,
    });
    return true;
  } catch {
    return false;
  }
}
